module.exports = __webpack_public_path__ + "img/BRCA4_NK.2b79e6f9.png";